import { ColumnDef } from '@tanstack/react-table'
import { GetPlayerPlaylogData } from '@/modules/manage-player/type'
import { format } from 'date-fns'
import { th } from 'date-fns/locale'
import { Badge } from '@/common/ui/badge'
import { cn } from '@/common/utils'
import { PlayerPlayLogStatus } from '@/schema'

export const playlogColumns: ColumnDef<GetPlayerPlaylogData>[] = [
	{
		id: 'gameInfo',
		header: 'ข้อมูลเกม',
		cell: ({ row }) => {
			const session =
				row.original.promotionSessionId ||
				row.original.sessionId ||
				(row.original.walletType === 'MAIN' ? row.original.playerId : '-')
			return (
				<div className="space-y-1">
					<p>{row.original.game?.provider?.name || '-'}</p>
					<p className="text-xs text-muted-foreground">
						เกม: {row.original.game?.name || '-'}
					</p>
					<p className="font-mono text-xs text-muted-foreground">
						TX: {row.original.providerTransactionId || '-'}
					</p>
					<p className="text-xs text-muted-foreground">Session: {session}</p>
				</div>
			)
		},
	},
	{
		accessorKey: 'status',
		header: 'สถานะ/เวลา',
		cell: ({ row }) => {
			return (
				<div className="space-y-1">
					<Badge
						variant="outline"
						className={cn(
							row.original.status === PlayerPlayLogStatus.SUCCESS
								? 'bg-green-50 text-green-500'
								: 'bg-red-50 text-red-500',
						)}
					>
						{row.original.status}
					</Badge>
					<p className="text-xs text-muted-foreground">
						{format(new Date(row.original.createdAt || ''), 'PPP HH:mm น.', {
							locale: th,
						})}
					</p>
				</div>
			)
		},
	},
	{
		accessorKey: 'info',
		header: 'กระเป๋า/ข้อมูล',
		cell: ({ row }) => {
			return (
				<div className="space-y-1">
					<p className="text-sm">กระเป๋า: {row.original.walletType || '-'}</p>
					<p className="max-w-[220px] truncate text-xs text-muted-foreground">
						{row.original.info || '-'}
					</p>
				</div>
			)
		},
	},
	{
		accessorKey: 'transferIn',
		header: 'ยอด/คงเหลือ',
		cell: ({ row }) => {
			const transferIn =
				typeof row.original.transferIn === 'number'
					? row.original.transferIn
					: 0
			const transferOut =
				typeof row.original.transferOut === 'number'
					? row.original.transferOut
					: 0
			const balanceBefore =
				typeof row.original.balanceBefore === 'number'
					? row.original.balanceBefore
					: 0
			const balanceAfter =
				typeof row.original.balanceAfter === 'number'
					? row.original.balanceAfter
					: 0
			return (
				<div className="space-y-1 text-sm">
					<p>
						เดิมพัน / จ่าย:{' '}
						<span className="text-green-600">{transferIn.toFixed(2)}</span> /{' '}
						<span className="text-red-600">{transferOut.toFixed(2)}</span>
					</p>
					<p className="text-muted-foreground">
						ก่อน / หลัง: {balanceBefore.toFixed(2)} / {balanceAfter.toFixed(2)}
					</p>
					<p className="text-muted-foreground">
						เทิร์นคงเหลือ: {row.original.turnoverAfter?.toFixed(2) || '-'}
					</p>
				</div>
			)
		},
	},
]
